import React from 'react'

import type { AgentChatMessage } from '~/api/agentChat'

import { AgentMessageBubble } from './AgentMessageBubble'
import { UserMessageBubble } from './UserMessageBubble'

export interface ChatMessageProps {
  message: AgentChatMessage
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  if (message.sender === 'user') {
    return <UserMessageBubble message={message} />
  }

  return <AgentMessageBubble message={message} />
}

export default ChatMessage
